import api from "./index";

// Get all listings with pagination
export const getPaginatedListings = async (page = 1, limit = 10, token) => {
  try {
    const res = await api.get("/listings", {
      params: { page, limit },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching paginated listings:", error);
    throw error;
  }
};

// Get a single listing by ID
export const getListing = async (listing_id) => {
  const res = await api.get(`/listings/${listing_id}`);
  return res.data;
};

// Create a new listing (authenticated)
export const createListing = async (listingData, token) => {
  const res = await api.post("/listings", listingData, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

// Create a guest listing (unauthenticated)
export const createGuestListing = async (listingData) => {
  const res = await api.post("/listings/guest", listingData);
  return res.data;
};

// Update a listing by ID (authenticated)
export const updateListing = async (listing_id, updatedData, token) => {
  const res = await api.put(`/listings/${listing_id}`, updatedData, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

// Delete a listing by ID (authenticated)
export const deleteListing = async (listing_id, token) => {
  const res = await api.delete(`/listings/${listing_id}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

// Get listings under a specific category
export const getListingsByCategory = async (category_id, location) => {
  console.log("DEBUG: Fetching listings for category:", category_id);
  console.log("DEBUG: User location:", location);
  const res = await api.get(`/listings/category/${category_id}`, {
    params: { longitude: location.longitude, latitude: location.latitude },
  });
  return res.data;
};

export const queryListing = async (query, page = 1, limit = 10) => {
  const res = await api.get(`/listings/search`, {
    params: { query, page, limit },
  });
  return res.data;
};
